import { render, staticRenderFns } from "./HistoryR2.vue?vue&type=template&id=29ac2c46&scoped=true"
import script from "./HistoryR2.vue?vue&type=script&lang=js"
export * from "./HistoryR2.vue?vue&type=script&lang=js"
import style0 from "./HistoryR2.vue?vue&type=style&index=0&id=29ac2c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac2c46",
  null
  
)

export default component.exports